import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SimpleResponse } from '../models/generic-response.model';
import { delayedRetryHttp } from './shared/delayed-retry';
import { UtilityService } from './shared/utility.service';
import { CC, Bank, CheckCash, eContractFeeType, CMPaymentTxnResponse, CMPaymentTxn, CMPaymentItem, CMPaymentItem_Charge, PayListResponse, RetrieveCardResponse, RetrieveBankResponse, VendorCustrReq, Charge, CMPaymentTxnNoFee } from '../models/cm-contract';

@Injectable({
    providedIn: 'root'
})
export class PaymentService {

    private baseUrl: string;
    private api: string = 'api/Payment';


    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }

    async getVendorCustomerId(encryptedUser: string, vendorCustrReq : VendorCustrReq): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/Vendor_GetCustomerId`, vendorCustrReq, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "PaymentService", "getVendorCustomerId"); });
        return a;
    }

    async Charge(encryptedUser: string, charge: Charge): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/Charge`, charge, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "PaymentService", "Charge"); });
        return a;
    }

    async addCreditCard(encryptedUser: string, cc: CC): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/AddCreditCard`, cc, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "PaymentService", "addCreditCard"); });
        return a;
    }

    async addBankAccount(encryptedUser: string, bank: Bank): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/AddBankAccount`, bank, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "PaymentService", "addBankAccount"); });
        return a;
    }

    async addCheckCash(encryptedUser: string, cc: CheckCash): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/AddCheckCash`, cc, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "PaymentService", "addCheckCash"); });
        return a;
    }

    async cMPaymentTxn_LoadByFee(encryptedUser: string, clpCompanyId: number, cmContractId: number, cmMemberId: number, cmMemberFeeId: number): Promise<CMPaymentTxnResponse | void> {
        const a = await this.httpClient
            .get<CMPaymentTxnResponse>(`${this.baseUrl}/CMPaymentTxn_LoadByFee/${clpCompanyId}/${cmContractId}/${cmMemberId}/${cmMemberFeeId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "PaymentService", "cMPaymentTxn_LoadByFee"); });
        return a;
    }

    async CMPaymentItem_Get(encryptedUser: string, cmMemberFeeId: number): Promise<CMPaymentItem[] | void> {
        const a = await this.httpClient
            .get<CMPaymentItem[]>(`${this.baseUrl}/CMPaymentItem_Get/${cmMemberFeeId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "PaymentService", "CMPaymentItem_Get"); });
        return a;
    }

    async CMPaymentTxn_Create(encryptedUser: string, cmPaymentTxn: CMPaymentTxn): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/CMPaymentTxn_Create`, cmPaymentTxn, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "PaymentService", "CMPaymentTxn_Create"); });
        return a;
    }

    async CMPaymentTxn_CreateNoFee(encryptedUser: string, cmPaymentTxn: CMPaymentTxnNoFee): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/CMPaymentTxn_CreateNoFee`, cmPaymentTxn, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "PaymentService", "CMPaymentTxn_CreateNoFee"); });
        return a;
    }

    async CMPaymentTxn_Delete(encryptedUser: string, cmPaymentTxnID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/CMPaymentTxn_Delete/${cmPaymentTxnID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "PaymentService", "CMPaymentTxn_Delete"); });
        return a;
    }

    async CMPaymentItem_Create(encryptedUser: string, cmPaymentItem: CMPaymentItem): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/CMPaymentItem_Create`, cmPaymentItem, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "PaymentService", "CMPaymentItem_Create"); });
        return a;
    }
    async cMPaymentItem_Charge_Get(encryptedUser: string, contractID: number, memberID: number): Promise<PayListResponse | void> {
        const a = await this.httpClient
            .get<PayListResponse>(`${this.baseUrl}/CMPaymentItem_Charge_Get/${contractID}/${memberID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "PaymentService", "CMPaymentItem_Charge_Get"); });
        return a;
    }

    async cMPaymentItem_Delete(encryptedUser: string, cmPaymentItemID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMPaymentItem_Delete/${cmPaymentItemID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "PaymentService", "CMPaymentItem_Charge_Get"); });
        return a;
    }

    async CMContract_isPaymentDone(encryptedUser: string, contractId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMContract_isPaymentDone/${contractId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "PaymentService", "CMContract_isPaymentDone"); });
        return a;
    }

    async CMPaymentItem_isPaymentDone_Update(encryptedUser: string, cmPaymentTxnID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMPaymentItem_isPaymentDone_Update/${cmPaymentTxnID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "PaymentService", "CMPaymentItem_isPaymentDone_Update"); });
        return a;
    }

    async retrieveCreditCard(encryptedUser: string, contractid: number, contactid: number, cmpaymentTxnID: number, vendorCustomerId: string): Promise<RetrieveCardResponse | void> {
        const a = await this.httpClient
            .get<RetrieveCardResponse>(`${this.baseUrl}/RetrieveCreditCard/${contractid}/${contactid}/${cmpaymentTxnID}/${vendorCustomerId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "PaymentService", "retrieveCreditCard"); });
        return a;
    }

    async retrieveBank(encryptedUser: string, contractid: number, contactid: number, cmpaymentTxnID: number, vendorCustomerId: string): Promise<RetrieveBankResponse | void> {
        const a = await this.httpClient
            .get<RetrieveBankResponse>(`${this.baseUrl}/RetrieveBank/${contractid}/${contactid}/${cmpaymentTxnID}/${vendorCustomerId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "PaymentService", "retrieveBank"); });
        return a;
    }

    async updateCreditCard(encryptedUser: string, cc: CC, contactId: number, cmpaymentTxnID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/UpdateCreditCard/${contactId}/${cmpaymentTxnID}`, cc, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "PaymentService", "UpdateCreditCard"); });
        return a;
    }

}
